import React from 'react'
import { Badge, Select, type BadgeColor } from '@enamelai/design-system'
import { TxPlanStatus, TX_PLAN_STATUS } from '@dataTypes/treatmentPlan.types'

type TxPlanStatusDropdownProps = {
  value: TxPlanStatus
  onChange?: (newStatus: TxPlanStatus) => void
  readOnly?: boolean
}

const STATUS_OPTIONS = [
  { value: TX_PLAN_STATUS.PROPOSED, label: TX_PLAN_STATUS.PROPOSED },
  { value: TX_PLAN_STATUS.ACCEPTED, label: TX_PLAN_STATUS.ACCEPTED },
  { value: TX_PLAN_STATUS.COMPLETED, label: TX_PLAN_STATUS.COMPLETED },
  { value: TX_PLAN_STATUS.REJECTED, label: TX_PLAN_STATUS.REJECTED },
]

const TX_PLAN_STATUS_BADGE_COLOR: Record<TxPlanStatus, BadgeColor> = {
  [TX_PLAN_STATUS.PROPOSED]: 'teal',
  [TX_PLAN_STATUS.ACCEPTED]: 'vivid-green',
  [TX_PLAN_STATUS.COMPLETED]: 'blue',
  [TX_PLAN_STATUS.REJECTED]: 'red',
}

const isTxPlanStatus = (next: unknown): next is TxPlanStatus =>
  typeof next === 'string' &&
  (Object.values(TX_PLAN_STATUS) as string[]).includes(next)

const stopHeaderToggle = (event: React.SyntheticEvent): void => {
  event.stopPropagation()
}

const TxPlanStatusDropdown: React.FC<TxPlanStatusDropdownProps> = ({
  value,
  onChange,
  readOnly = false,
}): React.ReactElement => {
  const color = TX_PLAN_STATUS_BADGE_COLOR[value] ?? 'teal'

  if (readOnly) {
    return (
      <div
        className="tx-plan-status-dropdown"
        onClick={stopHeaderToggle}
        onMouseDown={stopHeaderToggle}
      >
        <Badge mode="tinted" color={color} label={value} />
      </div>
    )
  }

  return (
    <div
      className="tx-plan-status-dropdown"
      onClick={stopHeaderToggle}
      onMouseDown={stopHeaderToggle}
    >
      <Select
        label=""
        className="tx-plan-status-select"
        value={value}
        options={STATUS_OPTIONS}
        onChange={(nextValue): void => {
          if (!isTxPlanStatus(nextValue) || nextValue === value) {
            return
          }
          onChange?.(nextValue)
        }}
      />
    </div>
  )
}

export default TxPlanStatusDropdown
